import { render } from "./fees.vue?vue&type=template&id=1ef9ec43&scoped=true"
import script from "./fees.vue?vue&type=script&lang=js"
export * from "./fees.vue?vue&type=script&lang=js"

import "./fees.vue?vue&type=style&index=0&id=1ef9ec43&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef9ec43"]])

export default __exports__